import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

const BASE = `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api`;

export const GetCustomerMachineDetails = () => axios({
  method: 'get',
  url: `${BASE}/getCustomerMachineDetails`,
  authRequired: true,
});
